var React = require('react');

function Previous (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 19.2902V4.70985C21 3.94502 20.1763 3.46331 19.5097 3.83827L6.54947 11.1284C5.86982 11.5107 5.86982 12.4893 6.54947 12.8716L19.5097 20.1617C20.1763 20.5367 21 20.055 21 19.2902Z","fill":"currentColor","key":0}),React.createElement("rect",{"x":"3","y":"4","width":"4","height":"16","rx":"0.5","fill":"currentColor","key":1})]);
}

Previous.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Previous;

Previous.default = Previous;
